var sliderFeatures = tns({
	"container": ".slider-features",
	"controlsContainer": ".slider-features-controls",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"nav": true,
    "mouseDrag": true,
    "rewind": false,
	"speed": 400,
    "slideBy": 1,
	"loop": true,
	"fixedWidth": 316,
	"gutter": 32,
	"responsive": {
		"576": {
			"center": true
		},
		"768": {
			"nav": true,
            "items": 2,
            "slideBy": 2,
            "controls": true,
            "center": false,
            "fixedWidth": 316,
            "gutter": 32
		},
		"992": {
			"nav": true,
            "items": 2,
            "slideBy": 2,
            "controls": false,
            "center": false,
            "fixedWidth": 316,
            "gutter": 32
		},
		"1280": {
            "nav": true,
            "items": 2,
            "slideBy": 2,
            "controls": true,
            "center": false,
            "fixedWidth": 486,
            "gutter": 32
		}
	}
});